<template>
  <v-dialog v-model="open" persistent max-width="600px">
    <material-card color="primary" :title="title" :text="item.drug">
      <v-form ref="form" v-model="validForm">
        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex xs12 sm6 md6>
              <v-select
                clearable
                md4
                v-model="item.protocol_id"
                :items="protocols"
                label="Protocol"
                :rules="validators.treatment.protocol"
                item-value="id"
                item-text="name"
                :readonly="!$can('upsert', 'treatment')"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Drug"
                :disabled="false"
                v-model="item.drug"
                :rules="validators.treatment.drug"
                @keydown.space.prevent
                :readonly="!$can('upsert', 'treatment')"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Minimum Dose"
                v-model="item.min_dose"
                @keydown.space.prevent
                :readonly="!$can('upsert', 'treatment')"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Maximum Dose"
                v-model="item.max_dose"
                @keydown.space.prevent
                :readonly="!$can('upsert', 'treatment')"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-select
                style="margin-top:14px"
                clearable
                v-model="item.measure_unit"
                :items="measureUnits"
                label="Measure Unit"
                :rules="validators.treatment.measure_unit"
                item-value="id"
                item-text="name"
                :readonly="!$can('upsert', 'treatment')"
              ></v-select>
            </v-flex>

          <v-flex xs12 sm6 md6>
            <v-checkbox 
              label="Open drug" 
              v-model="item.open_drug"
              v-bind:false-value="0"
              v-bind:true-value="1"
              :readonly="!$can('upsert', 'treatment')"
              ></v-checkbox>
          </v-flex>


          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>


        <v-tooltip top close-delay='2000' min-width='350px' v-if="$can('upsert', 'treatment')">
          <template slot="activator" slot-scope="{ on }">
              <v-btn
                  v-on="item.pdf ? on : {}"
                  class="mx-1 font-weight-light"
                  :disabled="isNew || !$can('upsert', 'treatment')"
                  @click="pickFile"
                  :color="item.pdf ? 'green' : 'pink' ">
                  <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; PDF
              </v-btn>
            </template>
            <span><a @click="downloadPdf">{{item.pdf}}</a></span>
        </v-tooltip>


        <v-btn class="mx-1 font-weight-light" color="success" @click="close()">Close</v-btn>

        <v-btn
          v-if="$can('upsert', 'treatment')"
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!checkSave() && !validForm"
          @click="save()"
          >Save</v-btn>
      </v-flex>
    </material-card>

    <input
      id="file"
      ref="file"
      type="file"
      style="display: none"
      accept=".pdf, application/pdf"
      @change="handleFileUpload()"
    />


  </v-dialog>
</template>

<script>
import { upsert, getDetail, measureUnits, uploadPdf, downloadPdf } from "@/api/treatment";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  data() {
    return {
      validForm: true,
      validators,
      siteId: null,
    };
  },
  mounted() {
  },
  watch: {
    open() {
      this.siteId = null
      if (this.isNew) {
        this.$refs.form.reset();
      }
    },
    item: {
      handler(v) {
        if (this.item.drug) {
          this.item.map = this.item.drug.toLowerCase() + '_' + this.item.dose;
        }
      },
      deep: true
    }
  },
  computed: {
    open() {
      return this.$store.getters.treatmentDialog;
    },
    item: {
      get() {
        return this.$store.getters.treatmentItem;
      },
      set() {
      }
    },
    protocols() {
      return this.$store.getters.protocols;
    },
    arms() {
      if (!this.item.protocol_id)
        return [];
      return this.protocols.filter( el => {
        return el.id == this.item.protocol_id
      })[0].arms || [];
    },
    measureUnits() {
      return measureUnits();
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      //return this.isNew ? "New Treatment" : "Edit Treatment";
      return 'Treatment Details';
    }
  },
  methods: {
    getData() {
      return getDetail(this.item.id, this.projectId).then(data => {
        const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));
        this.$store.commit("app/treatmentItem", newItem);
      });
    },
    close() {
      this.$store.dispatch("app/closeTreatmentDialog");
    },
    checkSave() {
      return !this.isNew
    },
    save() {
      if(this.item.drug){
        this.item.drug = this.item.drug.trim();
      }
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Treatment updated correctly",
            color: "success"
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
         // this.$store.commit("app/treatmentItem", newItem);
          this.$root.$emit('updateTreatments', newItem);
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Treatment update. " +
              e.response.data.message,
            color: "error"
          });
        });
    },

    pickFile(type) {
      // this.uploadFileType = type
      this.$refs.file.click();
    },
    handleFileUpload(event) {

      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.$store.dispatch("app/startLoading");
      let formData = new FormData();
      formData.append('file', file);
      formData.append('id', this.item.id);
      formData.append('uploadType', this.uploadFileType);

      uploadPdf(formData).then( data => {
        this.$store.dispatch("app/stopLoading");
        this.item.pdf = data.pdf;
        this.$root.$emit('updateTreatments', this.item);
        //issue 679
        this.save();
        //issue 679
      }).catch( () => {
        this.$store.dispatch("app/openSnackbar", {
          message: "An Error occurred during pdf upload " + e.response.data.message,
          color: "error"
        });
        this.$store.dispatch("app/stopLoading");
      }).finally( () => {
        this.$store.dispatch("app/stopLoading");
      });
      this.$refs.file.value = '';
    },
    downloadPdf() {

      // this.pdfPreview = true

      this.$store.dispatch("app/startLoading");
      downloadPdf(this.item.id, '', this.item.pdf).then( d => {
        this.$store.dispatch("app/stopLoading");
      }).catch( e => {
         this.$store.dispatch("app/openSnackbar", {
            message: "An Error occurred during pdf download : " + (e.response.data.message || e.response.statusText),
            color: "error"
          });
         this.$store.dispatch("app/stopLoading");
      });
    },
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
